<div class="card monitor">
  <div class="card-header">
    <strong>{{monitor.monitorName}} ({{monitor.aspaId}})</strong>
    @if (Areas.AnnaPerenna | can: 'ReadWrite') {
      <span class="fa-light fa-pen-to-square fa-lg cursorPointer ml-3" (click)="editZones()"
      ></span>
    }
    <span class="float-right fa fa-xmark cursorPointer" (click)="removeFromList()"></span>
    <div class="mt-1 mb-1">
      @if (!profileEdit) {
        <div>
          @if (monitor.hasOwnProperty('profile')) {
            <span class="cursorPointer" (click)="editProfile()"
            >{{'PROFILE' |translate}}: {{monitor.profileName}}</span>
          }
          @if (!monitor.hasOwnProperty('profile')) {
            <span class="cursorPointer" (click)="editProfile()"
            >{{'SELECT_PROFILE' |translate}}</span>
          }
        </div>
      }
      @if (profileEdit) {
        <div class="form">
          <div class="form-group">
            <mat-form-field class="selector-full-width">
              <mat-select [(ngModel)]="selectedProfile">
                @if (!selectedProfile) {
                  <mat-option value=undefined disabled>{{'SELECT_PROFILE'
                  |translate}}</mat-option>
                }
                @for (profile of profiles; track profile) {
                  <mat-option [value]="profile">
                    {{profile.name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-group">
            <button (click)="saveProfile()" class="btn btn-outline-primary mr-2">{{'SAVE' |translate}}</button>
            <button (click)="editProfile()" class="btn btn-outline-danger">{{'CANCEL' |translate}}</button>
          </div>
        </div>
      }
    </div>
  </div>
  <div class="card-body">
    @if (monitor.monitoringEnabled) {
      <div>
        <div class="row mb-1">
          @if (monitor.alert) {
            <div class="float-left ml-3 mt-3">
              <span class="fa-solid fa-exclamation fa-3x text-danger"></span>
            </div>
          }
          <div class="float-left ml-3">
            @if (monitor.icon) {
              <img [src]="getIconPath(monitor.icon)" class="apStateIcon" alt="">
            }
          </div>
          <div class="float-left ml-3">
            <strong>{{getIconText()}}</strong><br>
            @if (monitor.icon !== 'unknown') {
              <span>@if (this.monitor.eventTime && this.monitor.eventTime !== '0001-01-01T00:00:00Z') {
                <span
                  >{{'STARTED'|translate}}:
                  {{monitor.eventTime |moment: 'LT'}} <br>({{calculateStateDuration()}})</span>
                }</span>
              }
            </div>
          </div>
          <!-- Show notification if monitor has an active alert -->
          @if (monitor.alert) {
            <div class="alert alert-danger alertActive">
              <span class="fa-light fa-fw fa-bell"></span> {{'AP_ALERT_' + monitor.alertType |translate}}
            </div>
          }
          <!-- Info if superactive times are configured but not active yet -->
          @if ((monitor.superActiveStart && monitor.superActiveEnd) && !checkSuperActiveTime()) {
            <div class="superActive"
              >
              <small><span class="fa-light fa-fw fa-info-circle"></span> {{'AP_SUPERACTIVE_INFO' |translate}}
            {{monitor.superActiveStart}} - {{monitor.superActiveEnd}}</small>
          </div>
        }
        <!-- Info if superactive times are configured and active -->
        @if ((monitor.superActiveStart && monitor.superActiveEnd) && checkSuperActiveTime()) {
          <div class="superActive"
            >
            <small><span class="fa-light fa-fw fa-info-circle"></span> {{'SUPERACTIVE_TIME' |translate}}
          {{monitor.superActiveStart}} - {{monitor.superActiveEnd}}</small>
        </div>
      }
    </div>
  }
</div>
</div>